import { stockApi } from '../api';

export const stockRepo = {
    getAll: (params) => stockApi.getAll(params),
    getMyShops: (params) => stockApi.getMyShops(params),
    getById: (stockId) => stockApi.getById(stockId),
    getByShop: (shopId) => stockApi.getByShop(shopId),
    getAvailableForSale: (shopId) => stockApi.getAvailableForSale(shopId),
    getMyShopsAvailableForSale: () => stockApi.getMyShopsAvailableForSale(),
    getTotalByShop: (shopId) => stockApi.getTotalByShop(shopId),
    getByDateRange: (params) => stockApi.getByDateRange(params),
    getWithSales: (stockId) => stockApi.getWithSales(stockId),
    create: (data) => stockApi.create(data),
    update: (stockId, data) => stockApi.update(stockId, data),
    toggleStatus: (stockId) => stockApi.toggleStatus(stockId),
};
